import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/Logo1.png";
import { makeAuthenticatedRequest } from "../utils/api";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { ForgotOtp } from "../redux/LoginSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify"; // Make sure react-toastify is installed and imported
import { ToastContainer } from "react-toastify";

const SetNewPassword = () => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });

  const validatePassword = (password) => {
    // At least 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character
    const re =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,200}$/;
    return re.test(password);
  };

  const ForgOtp = useSelector((state) => state.login?.ForgOtp);
  //console.log("ForgOtp:", ForgOtp);
  const mid = ForgOtp?.userdatils?.user_id || "";
  console.log("ForgOtp:", ForgOtp);
  console.log("mid:", mid);


  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {
      password: "",
      confirmPassword: "",
    };
    let isValid = true;

    // Password validation
    if (!password.trim()) {
      newErrors.password = "Password is required.";
      isValid = false;
    } else if (!validatePassword(password)) {
      newErrors.password =
        "Password must be at least 8 characters with 1 uppercase, 1 lowercase, 1 special character and 1 number.";
      isValid = false;
    }

    // Confirm password validation
    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Please confirm your password.";
      isValid = false;
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
      isValid = false;
    }

    setErrors(newErrors);

    // if (isValid) {
    //   setShowSuccess(true);
    //   setTimeout(() => {
    //     navigate("/login");
    //   }, 1500); // Navigate after showing success message for 1.5 seconds
    // }

    if (!isValid) return;

    try {
      const requestData = JSON.stringify({
        mid: mid,
        new_password: password,
      });
    
      const encrypted = encrypt(requestData);
    
      const data = await makeAuthenticatedRequest(
        "POST",
        "/forgot/password/update",
        { encrypted }
      );
    
      if (!data) {
        toast.error("No response from server.");
        return;
      }
    
      const decryptdata = decrypt(data);
      const fixedString = decryptdata
        .replace(/\\"/g, '"')
        .replace(/^"|"$/g, "");
    
      const jsonObject = JSON.parse(fixedString);
    
      if (jsonObject?.Status === "200") {
        toast.success(jsonObject.token || "Password updated successfully.");
        navigate("/login");
        console.log("TOKEN:", jsonObject.token);

      } else {
        const errorMsg = jsonObject?.Err || "Something went wrong.";
        toast.error(errorMsg);
      }
    
    } catch (error) {
      toast.error("Request failed.");
      console.error("Error:", error);
    }
    
  };

  return (
    <>
      <style>{`
                @keyframes gradient {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }
                body {
                    background: linear-gradient(45deg, rgba(238, 119, 82,0.2), rgba(231, 60, 126,0.2), rgba(35, 166, 213,0.2), rgba(35, 213, 171,0.2));
                    background-size: 400% 400%;
                    animation: gradient 15s ease infinite;
                    height: 100vh;
                }
            `}</style>
      <div className="relative overflow-hidden h-screen">
        {/* Success Message Popup */}
        {showSuccess && (
          <div className="fixed top-4 right-4 z-50 animate-fade-in">
            <div className="bg-[#635BFF] text-white px-4 py-2 rounded-lg shadow-lg flex items-center">
              <span className="material-symbols-outlined mr-2">
                check_circle
              </span>
              Password Reset Successfully...
            </div>
          </div>
        )}
        <div className="flex h-full justify-center items-center px-4">
          <div className="rounded-xl shadow-md bg-white p-8 w-full md:w-[480px] border-none">
            <div className="flex flex-col gap-2 p-0 w-full">
              <div className="mb-2 flex items-center justify-center">
                <img src={Logo} alt="Company Logo" className="h-20 md:h-24" />
              </div>
              <p className="text-sm text-center text-gray-600 my-3">
                Password Reset
              </p>
              <form
                onSubmit={handleSubmit}
                action="#"
                method="POST"
                className="w-full"
                autoComplete="off"
              >
                <div className="mb-4">
                  <label
                    htmlFor="password"
                    className="block mb-2 text-sm font-medium"
                  >
                    Set New Password<span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type={showNewPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      maxLength="150"
                      className={`w-full p-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.password
                          ? "border-[#DC2626] focus:ring-[#DC2626]"
                          : "focus:ring-[#635BFF]"
                        }`}
                    />
                    <span
                      className="absolute right-3 top-3 cursor-pointer text-gray-600 dark:text-gray-400"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                      {showNewPassword ? (
                        <EyeOff size={18} />
                      ) : (
                        <Eye size={18} />
                      )}
                    </span>
                  </div>
                  {errors.password && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.password}
                    </p>
                  )}
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="confirmpassword"
                    className="block mb-2 text-sm font-medium"
                  >
                    Confirm Password<span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirmpassword"
                      name="confirmpassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      maxLength="150"
                      className={`w-full p-2 border rounded-lg focus:outline-none focus:ring-2 ${errors.confirmPassword
                          ? "border-[#DC2626] focus:ring-[#DC2626]"
                          : "focus:ring-[#635BFF]"
                        }`}
                    />
                    <span
                      className="absolute right-3 top-3 cursor-pointer text-gray-600 dark:text-gray-400"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? (
                        <EyeOff size={18} />
                      ) : (
                        <Eye size={18} />
                      )}
                    </span>
                  </div>
                  {errors.confirmPassword && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.confirmPassword}
                    </p>
                  )}
                </div>
                <button
                  type="submit"
                  className="w-full bg-[#6B65FF] text-white rounded-xl p-2"
                >
                  Sign Up
                </button>
              </form>
            </div>
          </div>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </>
  );
};

export default SetNewPassword;
